import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "background"
}

import BackgroundBlurFilter from "@/components/Background/BackgroundBlurFilter.vue";
import BackgroundParallax from "@/components/Background/BackgroundParallax.vue";
import store from "@/store";

import {defineComponent} from "vue";

const __default__ = defineComponent({
    data() {
        return {
            backgroundParallaxImages: [
                {
                    image: '100',
                    depth: 0.15,
                    opacity: 1,
                    blur: false,
                    dynamicBlur: 7,
                },
                {
                    image: '101',
                    depth: 0.3,
                    opacity: 0.3,
                    blur: true,
                    dynamicBlur: 13,
                },
                {
                    image: '201',
                    depth: 0.8,
                    opacity: 0.15,
                    blur: false,
                    dynamicBlur: false,
                },
            ],
        }
    },

    props: {
        withBlur: {
            type: Boolean,
            required: false,
            default: true,
        }
    }
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'BackgroundContainer',
  setup(__props) {

_useCssVars(_ctx => ({
  "c3514e74": (`url("/img/page/landing/bg/100.webp")`)
}))


return (_ctx: any,_cache: any) => {
  return (_unref(store).state.pageSize.width > _unref(store).state.mobileVersionThresholdWidth)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(BackgroundParallax, { images: _ctx.backgroundParallaxImages }, null, 8, ["images"]),
        (_ctx.withBlur)
          ? (_openBlock(), _createBlock(BackgroundBlurFilter, { key: 0 }))
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})